import { AppFactory } from "@opendash/core";
import { $parse, CustomParseFieldProps } from "@opendash/plugin-parse";
import { CustomMesOrderCols } from "./components/CustomMesOrderCols";
import {
  DurationParseComponent,
  DurationSettingsComponentsProps,
} from "./components/DurationSettingsComponent";
import OrderCompleteField from "./components/MESOrderFields/OrderCompleteField";
import ParseOrderArticleField from "./components/MESOrderFields/ParseOrderArticleField";
import ParseOrderStatusTag from "./components/MESOrderFields/ParseOrderStatusTag";
import { PlannedTimeField } from "./components/MESOrderFields/PlannedTimeField";
import { ParseOrderActionsComponent } from "./components/OrderActionsComponent";
import { Order } from "./types";
class MES {
  private static _instance: MES;
  static getInstance() {
    if (!this._instance) {
      this._instance = new MES();
    }
    return this._instance;
  }
  constructor() {
    MES._instance = this;
  }

  init = async (factory: AppFactory) => {
    $parse.ui.setClassConfig({
      className: "OD3_MES_OrderPlan",
      createFields: [
        "ordernr",
        "article",
        "planStart",
        "planEnd",
        "order_quantity",
        "tenant",
        "source",
      ],
      displayFields: [
        "ordernr",
        "article",
        "planStart",
        "order_quantity",
        "source",
      ],
      editFields: [
        "ordernr",
        "planStart",
        "planEnd",
        "article",
        "order_quantity",
        "tenant",
        "source",
      ],
      titleFields: ["ordernr"],
      translationPrefix: "openware:admin.classes.",

      customFields: {
        source: (props) => ParseOrderActionsComponent(props),
        planStart: (props) => PlannedTimeField(props),
        article: (props) => ParseOrderArticleField(props),
      },
      showCustomFieldsWhenEmpty: true,
    });
    $parse.ui.setDefaultView("OD3_MES_OrderPlan", {
      type: "table",
      customCols: CustomMesOrderCols,
    });

    $parse.ui.setClassConfig<Order>({
      className: "OD3_MES_Order",

      createFields: [
        "ordernr",
        "source",
        "start",
        "article",
        "order_quantity",
        "targettime",
      ],
      displayFields: [
        "ordernr",
        "status",
        "source",
        "start",
        "duration",
        "articlenr",
        "articlename",
        "order_quantity",
        "targettime",
      ],
      editFields: [
        "ordernr",
        "source",
        "start",
        "duration",
        "articlenr",
        "articlename",
        "order_quantity",
        "targettime",
      ],
      titleFields: ["ordernr"],
      translationPrefix: "openware:admin.classes.",
      beforeSave: (object) => {
        if (object.get("article")) {
          if (!object.get("articlename"))
            object.set("articlename", object.get("article").get("name"));
          if (!object.get("articlenr"))
            object.set("articlenr", object.get("article").get("artnr"));
          if (!object.get("targettime"))
            object.set("targettime", object.get("article").get("targettime"));
        }
        if (object.get("source")) {
          if (!object.get("tag")) {
            object.set("tag", object.get("source").get("tag"));
          }
        }
      },
      customFields: {
        status: (props: CustomParseFieldProps<Order>) => {
          return ParseOrderStatusTag(props);
        },
        duration: (props: CustomParseFieldProps<any>) => {
          const durationProps: CustomParseFieldProps<DurationSettingsComponentsProps> =
            {
              ...props,
              props: {
                unit: "ms",
                value: props.parseObject.get("duration") || 0,
              },
            };
          if (props.setValue) {
            return DurationParseComponent(durationProps);
          } else {
            return OrderCompleteField(durationProps);
          }
        },
        targettime: (props: CustomParseFieldProps<any>) => {
          const durationProps: CustomParseFieldProps<DurationSettingsComponentsProps> =
            {
              ...props,
              props: {
                unit: "ms",
                value: props.parseObject.get("targettime") || 0,
              },
            };

          return DurationParseComponent(durationProps);
        },
        setup_time: (props: CustomParseFieldProps<any>) => {
          const durationProps: CustomParseFieldProps<DurationSettingsComponentsProps> =
            {
              ...props,
              props: {
                unit: "ms",
                value: props.parseObject.get("setup_time") || 0,
              },
            };

          return DurationParseComponent(durationProps);
        },
      },
    });
    $parse.ui.setDefaultView("OD3_MES_Order", { type: "table" });

    $parse.ui.setClassConfig({
      className: "OD3_MES_Article",
      createFields: ["artnr", "name", "targettime"],
      displayFields: ["artnr", "name", "targettime"],
      editFields: ["artnr", "name", "targettime"],
      titleFields: ["artnr"],
    });
    $parse.ui.setDefaultView("OD3_MES_Article", {
      type: "table",
      //dateField: "start",
    });
  };
}
export default MES;
